import React, { useState, useEffect, useContext } from "react";
import { requestsClient } from "../utils/RequestsClients";
import { TokenContext } from "./TokenContext";

export const UserContext = React.createContext({
	user: null,
	userLoading: false,
	storeUser: () => {},
	getUser: () => {},
	logout: () => {},
});

export const UserProvider = ({ children }) => {
	const { appId, pathId } = useContext(TokenContext);
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState(null);
	const isCreator = false;

	const getUser = async () => {
		try {
			if (isCreator) {
				const storedUser = localStorage.getItem(appId + "_user");
				if (storedUser) {
					setUser(JSON.parse(storedUser));
				}
			} else {
				const token = localStorage.getItem(appId + "_token");
				const headers = token
					? { authorization: token, "x-wc-call": true }
					: {};
				let response = await requestsClient.get(
					"user",
					{
						headers: headers,
					},
					undefined,
					pathId
				);
				if (response.data.user && response.data.user.activatedAt === null) {
					localStorage.removeItem(appId + "_token");
					setUser(null);
				} else {
					setUser(response.data.user);
				}
			}
		} catch (error) {
			console.log(error);
			localStorage.removeItem(appId + "_user");
			localStorage.removeItem(appId + "_token");
			setUser(null);
		}
		setLoading(false);
	};

	useEffect(() => {
		if (appId) {
			getUser();
		} else {
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [appId]);

	const storeUser = async (user) => {
		if (isCreator) {
			if (user) {
				localStorage.setItem(appId + "_user", JSON.stringify(user));
			} else {
				localStorage.removeItem(appId + "_user");
			}
		}

		setUser(user);
	};

	const logout = () => {
		localStorage.removeItem(appId + "_token");
		localStorage.removeItem(appId + "_user");
		setUser(null);
	};

	return (
		<UserContext.Provider
			value={{ user, storeUser, getUser, logout, userLoading: loading }}
		>
			{children}
		</UserContext.Provider>
	);
};

